module.exports = __webpack_public_path__ + "static/media/Sidewalk Strut.b49bd0eb.jpg";